import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import { formatErrorMessage } from '../../util/helpers/registerRejectErrorCodeHelper';
import {
  CREATE_CUSTODIAN,
  GET_CUSTODIANS,
  UPDATE_CUSTODIAN,
} from '../actions/custodians/custodiansActionConstants';
import {
  createCustodianRequest,
  getCustodiansRequest,
  updateCustodianRequest,
} from '../../request/custodiansRequest';
import {
  createCustodianError,
  createCustodianSuccess,
  getCustodiansError,
  getCustodiansSuccess,
  updateCustodianError,
  updateCustodianSuccess,
} from '../actions/custodians/custodiansActions';

function* getCustodians({ payload }) {
  try {
    const { data } = yield call(getCustodiansRequest, payload);
    if (data) {
      yield put(getCustodiansSuccess(data));
    }
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(getCustodiansError(errMsg));
  }
}

function* createCustodian({ payload }) {
  try {
    yield call(createCustodianRequest, payload);
    yield put(createCustodianSuccess(true));
    if (payload?.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(createCustodianError(errMsg));
  }
}

function* updateCustodian({ payload }) {
  try {
    yield call(updateCustodianRequest, payload);
    yield put(updateCustodianSuccess(true));
    if (payload?.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(updateCustodianError(errMsg));
  }
}

export default function* documentsSaga() {
  return yield all([
    takeLatest(GET_CUSTODIANS, getCustodians),
    takeLatest(CREATE_CUSTODIAN, createCustodian),
    takeLatest(UPDATE_CUSTODIAN, updateCustodian),
  ]);
}
